<template>
  <div class="warpper">
    <div class="container">
      <crumb />
      <div class="lg">
        <order-menu :menuType="4" />
        <div class="receiving_con">
          <div class="collec_title"><i>地址管理</i></div>
          <div class="side">
            <div class="collec_state">
              <div class="th1">收货人</div>
              <div class="th2">收货地址</div>
              <div class="th3">手机号码</div>
              <div class="th3">操作</div>
            </div>
            <ul
              class="collec_item"
              v-for="(item, index) in addressList"
              :key="index"
            >
              <li class="td1">{{ item.consignee }}</li>
              <li class="td2">{{ item.detailAddress }}</li>
              <li class="td3">{{ item.telePhone }}</li>
              <li class="td4">
                <div @click="updateAddress(index)">修改</div>
                <div @click="removeAddress(item.id)">删除</div>
              </li>
            </ul>
          </div>
          <div class="add_btn" @click="setAddress()">添加收货地址</div>
        </div>
      </div>
    </div>
  </div>
  <!-- <ConsigneeInformation
    :isShow="showSetAddress"
    @closeAddress="closeAddress"
    @saveAddress="saveAddress"
    @canClose="canClose"
  /> -->
<ConsigneeInformation
    :isShow="showSetAddress"
    :address="addressObj"
    v-if="showSetAddress"
    @canClose="canClose"
    @closeAddress="closeAddress"
    @saveAddress="saveAddress"
  />
</template>
<script>
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { posts } from '../../utils/posts'
import crumb from '../../components/bread-crumb/Index.vue'
import orderMenu from '../../components/order_menu.vue'
import ConsigneeInformation from '../../components/ConsigneeInformation.vue'
import { ElMessage } from 'element-plus'
export default {
  name: '收货地址',
  components: {
    crumb,
    orderMenu,
    ConsigneeInformation
  },
  setup () {
    const dialogVisible = ref(false)
    const showSetAddress = ref(false)
    const store = useStore()
    const addressList = ref([]) // 地址列表
    const editAddress = ref(false)
    const addressObj = ref({})
    const userInfo = store.state.userInfo
    // 修改地址
    const updateAddress = (idx) => {
      addressObj.value = addressList.value[idx]
      showSetAddress.value = true
    }

    // 删除地址
    const removeAddress = (id) => {
      posts(`address/remove/${userInfo.uid}`, { id: id }).then((res) => {
        ElMessage({
          message: '删除地址成功',
          type: 'success'
        })
        getAddressList()
      })
    }
    // 保存收货地址
    const saveAddress = () => {
      getAddressList()
    }
    // 增加收货地址
    const setAddress = () => {
      document.body.style.overflow = 'hidden'
      showSetAddress.value = true
    }

    // 关闭地址
    const closeAddress = () => {
      document.body.style.overflow = ''
      showSetAddress.value = false
    }
    // 关闭弹出层
    const canClose = () => {
      showSetAddress.value = false
      getAddressList()
    }
    // 获取地址列表
    const getAddressList = () => {
      posts(`address/get/${userInfo.uid}`, {}).then((res) => {
        addressList.value = res.data
      })
    }
    onMounted(() => {
      getAddressList()
    })
    return {
      addressObj,
      editAddress,
      updateAddress,
      removeAddress,
      saveAddress,
      addressList,
      setAddress,
      closeAddress,
      canClose,
      showSetAddress,
      dialogVisible,
      getAddressList
    }
  }
}
</script>
<style lang="scss">
.container {
  width: 1200px;
}
.lg {
  display: flex;
  justify-content: space-between;
  margin: 36px 0 50px 0;
  .receiving_con {
    width: 880px;
    background: white;
    .dialog_body {
      padding: 0 10px;
      li {
        height: 48px;
        display: flex;
        align-items: center;
        margin: 0 0 12px 0;
        .dialog_lable {
          font-size: 16px;
          font-weight: 400;
          color: #3e3a39;
          flex: 0.5;
        }
        .dialog_input {
          flex: 2;
          border: 1px solid #eeeeee;
          height: 48px;
        }
      }
    }
    .add_btn {
      width: 164px;
      height: 56px;
      line-height: 56px;
      text-align: center;
      background: linear-gradient(90deg, #ff5e41 0%, #fc4353 100%);
      border-radius: 8px;
      margin: 36px 0 0 30px;
      color: white;
      font-size: 18px;
      cursor: pointer;
    }
    .side {
      margin: 30px 30px 0 30px;
      padding: 0 0 20px 0;
      border: 1px solid #eeeeee;
      .collec_item {
        padding: 20px 20px 0 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        color: #3e3a39;
        .td1 {
          flex: 1;
          text-align: center;
          padding: 0 5px;
        }
        .td2 {
          flex: 3;
          text-align: center;
          padding: 0 5px;
        }
        .td3 {
          flex: 1;
          padding: 0 5px;
          text-align: center;
        }
        .td4 {
          flex: 1;
          padding: 0 5px;
          display: flex;
          justify-content: space-evenly;
          div {
            cursor: pointer;
            color:#999999;
          }
        }
      }
      .collec_state {
        padding: 14px 20px;
        background: #f5f5f5;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        font-weight: 400;
        color: #3e3a39;
        .th1 {
          flex: 1;
          text-align: center;
        }
        .th2 {
          flex: 3;
          text-align: center;
        }
        .th3 {
          flex: 1;
          text-align: center;
        }
        .th4 {
          flex: 1;
          text-align: center;
        }
      }
    }
    .collec_title {
      height: 48px;
      padding: 12px 20px;
      font-size: 18px;
      font-weight: 600;
      color: #3e3a39;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #eeeeee;
      em {
        color: #fc4353;
      }
    }
  }
}
.el-dialog__header {
  background: #f5f5f5;
}

.el-button--primary:focus,
.el-button--primary:hover,
.el-button--primary {
  background: linear-gradient(90deg, #ff5e41 0%, #fc4353 100%);
  opacity: 1;
  border-radius: 8px;
  border: none;
}
</style>
